import React, { PureComponent } from 'react';

import Button from 'components/cosmos/button/button';
import { Modal } from 'components/cosmos/v2/modal';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

@translate()
export default class FileModal extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    confirmButtonLabel: PropTypes.string,
    hideProceed: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    title: PropTypes.string
  };

  handleConfirm = () => {
    const { onConfirm, onClose } = this.props;

    onConfirm?.();
    onClose?.();
  };

  render() {
    const {
      onClose,
      title,
      children,
      confirmButtonLabel = 'general.ok',
      t
    } = this.props;

    return (
      <Modal
        show
        onClose={onClose}
        aria-labelledby="file-modal-title"
        // Show modal above Cosmos drawer
        style={{ zIndex: 1050 }}
      >
        <Modal.Header>
          <h2 className="_text-4 _font-weight-bold _mb-0" id="file-modal-title">
            {t(title)}
          </h2>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer className="_d-flex _justify-content-end">
          <Button variation="secondary" onClick={onClose} className="_mr-2">
            {t('general.back')}
          </Button>
          <Button variation="primary" onClick={this.handleConfirm}>
            {t(confirmButtonLabel)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
